import { render, staticRenderFns } from "./Header-Box.vue?vue&type=template&id=12f81d6e&scoped=true&"
import script from "./Header-Box.vue?vue&type=script&lang=js&"
export * from "./Header-Box.vue?vue&type=script&lang=js&"
import style0 from "./Header-Box.vue?vue&type=style&index=0&id=12f81d6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f81d6e",
  null
  
)

export default component.exports